<template>
  <span v-if="repeatType === 'once'">{{
    $t('containers.emptyTemplateRepeatOnce', {
      date: formattedDate(referenceDate),
    })
  }}</span>
  <span v-else>
    <template v-if="parseInt(repeatInterval) > 1">
      {{
        $t('containers.emptyTemplateRepeatInterval', {
          num: repeatInterval,
          day: weekday(referenceDate),
        })
      }}
    </template>
    <template v-else>
      {{
        $t('containers.emptyTemplateRepeatWeekly', {
          day: weekday(referenceDate),
        })
      }}
    </template>
  </span>
</template>

<script>
import dateUtils from '@/components/mixins/dateUtils'

export default {
  name: 'EmptyingTemplateDescription',
  mixins: [dateUtils],
  props: {
    repeatType: { type: String, required: true },
    repeatInterval: { type: [Number, String] },
    referenceDate: { type: String, required: true },
  },
}
</script>
